import futuresStrategy from './futuresStrategy';
import strategicContract from './strategicContract';

export default {
  futuresStrategy,
  strategicContract,
};
